import { defineMessages } from 'react-intl';

const alternativeSignInMethodsMessages = defineMessages({
  header: {
    id: 'alternativeSignInMethods.header',
    defaultMessage: 'Update your sign in method',
    description: 'Main heading for sign in page.',
  },
  subHeader: {
    id: 'alternativeSignInMethods.subHeader',
    defaultMessage:
      'Your organization no longer supports signing in with AWS Partner Network',
    description: 'Sub heading for sign in page.',
  },
  linkingInfo: {
    id: 'alternativeSignInMethods.linkingInfo',
    defaultMessage:
      'You can choose to carry over your training activity to your new account',
    description: 'Informs the user of the ability to link their accounts',
  },
  lookupRequestError: {
    id: 'alternativeSignInMethods.lookupRequestError',
    defaultMessage: 'Oh no, something went wrong. Please try again.',
    description: 'When the email lookup API request fails.',
  },
});

export default alternativeSignInMethodsMessages;
